import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Download, Eye } from 'lucide-react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';

export default function CatalogSection() {
  const [catalogUrl, setCatalogUrl] = useState(null);

  // Firestore'dan site_config içindeki ayarları çekiyoruz
  useEffect(() => {
    const fetchCatalogSettings = async () => {
      try {
        const settingsDoc = await getDoc(doc(db, 'site_config', 'settings'));
        if (settingsDoc.exists() && settingsDoc.data().catalogUrl) {
          setCatalogUrl(settingsDoc.data().catalogUrl);
        }
      } catch (err) {
        console.error('Katalog ayarları çekilirken hata:', err);
      }
    };

    fetchCatalogSettings();
  }, []);

  return (
    <section data-testid="catalog-section" className="relative py-20 md:py-28 overflow-hidden bg-brand-dark">
      {/* Decorative shapes */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-pink/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-brand-blue/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex-1"
          >
            <span className="inline-block px-3 py-1 rounded-full bg-white/10 text-xs font-semibold uppercase tracking-widest text-white/50 mb-4">
              2025 Kataloğu
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight leading-tight mb-4">
              Ürün Kataloğumuzu<br />
              <span className="text-brand-pink">Keşfedin</span>
            </h2>
            <p className="text-white/50 text-base md:text-lg leading-relaxed max-w-md mb-8">
              Tüm ürünlerimiz ile ilgili detaylı bilgi almak için e-kataloğumuzu
              görüntüleyebilir veya indirebilirsiniz.
            </p>
            <div className="flex flex-wrap gap-3">
              {/* Eğer URL varsa gerçek bir <a> etiketi olarak aç, yoksa hata almamak için disabled gibi davran */}
              <a
                href={catalogUrl || '#'}
                target={catalogUrl ? "_blank" : "_self"}
                rel="noopener noreferrer"
                data-testid="catalog-view-btn"
                className={`inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-brand-dark text-sm font-medium hover:bg-white/90 transition-colors duration-200 shadow-lg ${!catalogUrl && 'opacity-50 cursor-not-allowed'}`}
                onClick={(e) => !catalogUrl && e.preventDefault()}
              >
                <Eye size={16} />
                {catalogUrl ? 'Kataloğu Görüntüle' : 'Katalog Hazırlanıyor'}
              </a>
              
              <a
                href={catalogUrl || '#'}
                download
                data-testid="catalog-download-btn"
                className={`inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-white/30 text-white text-sm font-medium hover:bg-white/10 transition-colors duration-200 ${!catalogUrl && 'opacity-50 cursor-not-allowed'}`}
                onClick={(e) => !catalogUrl && e.preventDefault()}
              >
                <Download size={16} />
                İndir
              </a>
            </div>
          </motion.div>

          {/* Visual */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex-1 flex justify-center"
          >
            <div className="relative w-64 md:w-80 aspect-[3/4]">
              <div className="absolute inset-0 bg-gradient-to-br from-brand-pink/30 to-brand-blue/30 rounded-2xl blur-2xl" />
              <div className="relative w-full h-full rounded-2xl bg-white/10 backdrop-blur border border-white/20 flex flex-col items-center justify-center gap-4 p-8">
                <div className="w-16 h-16 rounded-2xl overflow-hidden bg-white/10">
                  <img
                    src="https://customer-assets.emergentagent.com/job_ayz-modern-refresh/artifacts/v7g2xftl_bf9b2368-ab92-47b2-b299-567b89d2d406.jpeg"
                    alt="AyzPlastik"
                    className="w-full h-full object-cover brightness-0 invert"
                  />
                </div>
                <h3 className="text-white font-semibold text-lg text-center">
                  AyzPlastik
                </h3>
                <p className="text-white/40 text-sm text-center">
                  Ürün Kataloğu 2025
                </p>
                <div className="w-full h-px bg-white/10 my-2" />
                <div className="space-y-2 w-full">
                  <div className="h-2 bg-white/10 rounded-full w-full" />
                  <div className="h-2 bg-white/10 rounded-full w-3/4" />
                  <div className="h-2 bg-white/10 rounded-full w-5/6" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}